var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    viewBox: "0 0 10 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22 3.005a.725.725 0 0 0-1.01 0 .69.69 0 0 0 0 .99l2.856 2.8a.725.725 0 0 0 1.01 0l5.715-5.6a.69.69 0 0 0 0-.99.725.725 0 0 0-1.01 0L3.57 5.31z"
  })));
};
export default SvgCheck;